import React from 'react';
import { VolumeBlock } from './VolumeBlock';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section aria-labelledby="volumes-title" data-id="element-353" data-mp="3utm3io1d8bv3">
      <div className="bg-white pt-24 pb-4 px-4" data-id="element-354" data-mp="co93r2fet4in">
        <div className="max-w-4xl mx-auto text-center" data-id="element-355" data-mp="cnzclbimorbd">
          <p className="text-orange font-bold mb-3" data-id="element-356" data-mp="7owhojwd41h4">6 volumes · 1 complete progression</p>
          <h2 id="volumes-title" className="text-4xl md:text-5xl font-display font-extrabold mb-4 text-navy" data-id="element-357" data-mp="3g4ycmv2gsqbh">
            The Complete 6-in-1 System
          </h2>
          <p className="text-xl text-forest" data-id="element-358" data-mp="3c5h4tuzkfh35">
            From rider assessment to independent trail riding — every stage organized for you.
          </p>
        </div>
      </div>
      {volumes.map(volume => <VolumeBlock key={volume.number} volume={volume} total={volumes.length} data-id="element-359" data-mp="3l2hoxpflqt0s" />)}
    </section>;
}